import { BodyBox } from '@lbcamden/lib-react';
import { formatDMYWithTime } from '@lbcamden/shared-utils';
import { FunctionComponent } from 'react';
import { useParams } from 'react-router';

import { useProperty, useNote, useReferenceListDisplayValue } from '~/client/hooks/storeHooks';
import { useHandlePendingItem } from '~/client/hooks/useHandlePendingItem';
import { getPropertyBreadcrumbs, toNotePage, toPropertyPage } from '~/client/utils/navigation';

import { ItemDetails } from '../../common/ItemDetails';
import { PageTitle } from '../../common/PageTitle';
import { DirectoryUserInfo } from '../../shared/DirectoryUserInfo';
import { PageBreadcrumbs } from '../../shared/PageBreadcrumbs';
import { LoadInNotFoundPage } from '../LoadInNotFoundPage';

export const NotePage: FunctionComponent = () => {
  const { propertyId: propertyIdParam, noteId: noteIdParam } = useParams();
  const propertyId = parseInt(propertyIdParam!);

  const note = useNote(noteIdParam!);
  const property = useProperty(propertyId);
  const referenceListDisplayValue = useReferenceListDisplayValue();

  const { isPendingItem: isPendingNote } = useHandlePendingItem(
    note?.noteId,
    toPropertyPage(propertyId),
    (realId) => toNotePage(propertyId, realId),
  );

  if (!property || !note) {
    return <LoadInNotFoundPage />;
  }

  return (
    <BodyBox>
      <PageTitle title="Note" />
      <PageBreadcrumbs links={[...getPropertyBreadcrumbs(property), { name: 'Note' }]} />
      <ItemDetails
        titleLabel="Note"
        title={note.subject}
        information={[
          ['Type', referenceListDisplayValue('COMBNOTOBJ', note.type)],
          ['Subject', note.subject],
          // oxlint-disable-next-line react/jsx-key -- prop tuple, not rendered children
          ['Caution', note.caution ? <strong>Yes</strong> : 'No'],
          // oxlint-disable-next-line react/jsx-key -- prop tuple, not rendered children
          ['Created by', <DirectoryUserInfo camdenAccountName={note.createdBy} />],
          ['Created', isPendingNote ? 'Pending' : formatDMYWithTime(note.created)],
          ['Note', note.note],
        ]}
      />
    </BodyBox>
  );
};
